import React from "react";

/**
 * Door SVG filigree overlay — botanical floral motifs in soft gold.
 * Used as decorative overlay inside the door panels.
 */
export const DoorFiligree = ({ mirror = false }) => (
  <svg
    viewBox="0 0 200 400"
    preserveAspectRatio="xMidYMid meet"
    className="absolute inset-0 w-full h-full pointer-events-none"
    style={{ transform: mirror ? "scaleX(-1)" : "none" }}
  >
    <defs>
      <linearGradient id={`goldGrad-${mirror ? "r" : "l"}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E8D6A8" />
        <stop offset="50%" stopColor="#C5A059" />
        <stop offset="100%" stopColor="#8a6e3a" />
      </linearGradient>
    </defs>
    <g
      stroke={`url(#goldGrad-${mirror ? "r" : "l"})`}
      strokeWidth="1.2"
      fill="none"
      opacity="0.85"
    >
      {/* Top arch ornament */}
      <path d="M100 30 Q 60 60, 60 100 T 100 170" />
      <path d="M100 30 Q 140 60, 140 100 T 100 170" />
      <circle cx="100" cy="40" r="6" fill="#C5A059" />
      <circle cx="100" cy="40" r="10" />

      {/* Middle floral medallion area */}
      <circle cx="100" cy="200" r="34" />
      <circle cx="100" cy="200" r="48" strokeDasharray="2 4" />
      <path d="M100 166 Q 80 200, 100 234 Q 120 200, 100 166 Z" fill="#C5A059" opacity="0.18" />
      <path d="M66 200 Q 100 180, 134 200 Q 100 220, 66 200 Z" fill="#C5A059" opacity="0.18" />

      {/* Vines snaking down */}
      <path d="M100 250 C 70 280, 130 320, 100 360" />
      <path d="M100 250 C 130 280, 70 320, 100 360" />

      {/* Leaves */}
      <ellipse cx="78" cy="285" rx="6" ry="12" transform="rotate(-30 78 285)" fill="#9CA986" opacity="0.5" />
      <ellipse cx="122" cy="285" rx="6" ry="12" transform="rotate(30 122 285)" fill="#9CA986" opacity="0.5" />
      <ellipse cx="74" cy="320" rx="5" ry="10" transform="rotate(-40 74 320)" fill="#9CA986" opacity="0.5" />
      <ellipse cx="126" cy="320" rx="5" ry="10" transform="rotate(40 126 320)" fill="#9CA986" opacity="0.5" />

      {/* Small blooms */}
      <g fill="#C5A059" opacity="0.7">
        <circle cx="68" cy="120" r="3" />
        <circle cx="132" cy="120" r="3" />
        <circle cx="80" cy="80" r="2.5" />
        <circle cx="120" cy="80" r="2.5" />
      </g>

      {/* Bottom ornament */}
      <path d="M70 380 Q 100 360, 130 380" />
      <path d="M80 388 Q 100 376, 120 388" />
    </g>
  </svg>
);

export default DoorFiligree;
